import { Typography } from "antd";
import Segment, { SegmentContainer } from "components/atoms/Segment";
import PageLayout from "components/molecules/PageLayout";
import DataSets from "containers/DataSets";
import SchemaModels from "containers/SchemaModels";
import { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import SchemaAskAIContent from "components/organisms/SchemaAskAIContent";
import SchemaAssistantContent from "components/organisms/SchemaAssistantContent";

function usePreviousAction(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

const SchemaPage = (props) => {
    const history = useHistory();
    const { tenant, businessarea, schemaAction, schemaId } = useParams();
    const prevSchemaAction = usePreviousAction(schemaAction);
    const [showDataSets, setShowDataSets] = useState(false);
    const [selectedSchemaModelInfo, setSelectedSchemaModelInfo] = useState({ schemaModel: null, userBusinessArea: null });
    const [manageSchemaModelRef, setManageSchemaModelRef] = useState(null);

    const onSchemaModelListLoaded = () => {
        setShowDataSets(true);
    };

    const onSchemaModelListUnLoaded = () => {
        setShowDataSets(false);
        setSelectedSchemaModelInfo({ schemaModel: null, userBusinessArea: null });
    };

    const onSchemaModelSelected = ({ schemaModel, userBusinessArea }) => {
        history.push(`#${schemaModel.name}`);
        setSelectedSchemaModelInfo({ schemaModel, userBusinessArea });
    };

    return (
        <PageLayout
            key={`${businessarea}_schema_page`}
            border={false}
            mainContent={({ setBreadcrumbNavigationItems }) => {
                return (
                    <div className="flex size-full flex-col gap-2 overflow-hidden">
                        <SegmentContainer>
                            <Segment shadow>
                                <SchemaModels
                                    key={`${businessarea}_${schemaAction || "default"}_schema_model`}
                                    setBreadcrumbNavigationItems={setBreadcrumbNavigationItems}
                                    tenant={tenant}
                                    businessArea={businessarea.toLowerCase()}
                                    action={schemaAction}
                                    prevAction={prevSchemaAction}
                                    schemaId={schemaId}
                                    onManageSchemaModelRefReady={setManageSchemaModelRef}
                                    onSchemaModelListLoaded={onSchemaModelListLoaded}
                                    onSchemaModelListUnLoaded={onSchemaModelListUnLoaded}
                                    onSchemaModelSelected={onSchemaModelSelected}
                                ></SchemaModels>
                            </Segment>
                        </SegmentContainer>
                        {showDataSets && selectedSchemaModelInfo.schemaModel && (
                            <SegmentContainer>
                                <Segment shadow>
                                    <DataSets
                                        key={`${businessarea}_${(selectedSchemaModelInfo.schemaModel && selectedSchemaModelInfo.schemaModel.schemaId) || "default"}_schema_datasets`}
                                        selectedSchemaModel={selectedSchemaModelInfo.schemaModel}
                                        userBusinessArea={selectedSchemaModelInfo.userBusinessArea}
                                        tenant={tenant}
                                        businessArea={businessarea.toLowerCase()}
                                    ></DataSets>
                                </Segment>
                            </SegmentContainer>
                        )}
                    </div>
                );
            }}
            helpContent={<Typography>We're working on this documentation.</Typography>}
            askAIContent={<SchemaAskAIContent manageSchemaModelRef={manageSchemaModelRef} />}
            assistantContent={<SchemaAssistantContent manageSchemaModelRef={manageSchemaModelRef} />}
            assistantTitle="Schema Assistant"
        ></PageLayout>
    );
};

export default SchemaPage;
